export const initialState = {
    isDarkMode: false,
    mainLayout: 'app',
    theme: 'light',
    menu: 'vertical',
    layout: 'full',
    rtlClass: 'ltr',
    animation: '',
    navbar: 'navbar-sticky',
    locale: 'en',
    sidebar: false,
    languageList: [
        { code: 'zh', name: 'Chinese' },
        { code: 'da', name: 'Danish' },
        { code: 'en', name: 'English' },
        { code: 'fr', name: 'French' },
        { code: 'de', name: 'German' },
        { code: 'el', name: 'Greek' },
        { code: 'hu', name: 'Hungarian' },
        { code: 'it', name: 'Italian' },
        { code: 'ja', name: 'Japanese' },
        { code: 'pl', name: 'Polish' },
        { code: 'pt', name: 'Portuguese' },
        { code: 'ru', name: 'Russian' },
        { code: 'es', name: 'Spanish' },
        { code: 'sv', name: 'Swedish' },
        { code: 'tr', name: 'Turkish' },
        { code: 'ae', name: 'Arabic' },
    ],
    isShowMainLoader: true,
    semidark: false,
};

function resolveDarkMode(theme: string, currentIsDarkMode: boolean): boolean {
    if (theme === 'light') {
        return false;
    }
    if (theme === 'dark') {
        return true;
    }
    if (theme === 'system') {
        return !!(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
    }
    return currentIsDarkMode;
}

function applyDarkModeClass(isDarkMode: boolean): void {
    if (isDarkMode) {
        document.querySelector('body')?.classList.add('dark');
    } else {
        document.querySelector('body')?.classList.remove('dark');
    }
}

function applyAnimationClass(animation: string | undefined): void {
    if (!animation) {
        return;
    }
    const eleanimation: any = document.querySelector('.animation');
    eleanimation?.classList.add('animate__animated');
    eleanimation?.classList.add(animation);
}

export function indexReducer(state = initialState, action: any) {
    const { type, payload: actionPayload } = action;

    switch (type) {
        case 'toggleDirection': {
            localStorage.setItem('direction', actionPayload);
            document.querySelector('html')?.setAttribute('dir', actionPayload || 'ltr');
            return { ...state, direction: actionPayload };
        }
        case 'toggleMainLoader':
            return { ...state, isShowMainLoader: actionPayload };
        case 'setMainLayout':
            return { ...state, mainLayout: actionPayload };
        case 'toggleTheme': {
            const theme = actionPayload || state.theme;
            localStorage.setItem('theme', theme);
            const isDarkMode = resolveDarkMode(theme, state.isDarkMode || false);
            applyDarkModeClass(isDarkMode);
            return { ...state, theme, isDarkMode };
        }
        case 'toggleMenu': {
            const menu = actionPayload || state.menu;
            localStorage.setItem('menu', menu);
            return { ...state, sidebar: false, menu };
        }
        case 'toggleLayout': {
            const layout = actionPayload || state.layout;
            localStorage.setItem('layout', layout);
            return { ...state, layout };
        }
        case 'toggleRTL': {
            const rtlClass = actionPayload || state.rtlClass;
            localStorage.setItem('rtlClass', rtlClass);
            document.querySelector('html')?.setAttribute('dir', rtlClass || 'ltr');
            return { ...state, rtlClass };
        }
        case 'toggleAnimation': {
            const animation = actionPayload?.trim();
            localStorage.setItem('animation', animation);
            applyAnimationClass(animation);
            return { ...state, animation };
        }
        case 'toggleNavbar': {
            const navbar = actionPayload || state.navbar;
            localStorage.setItem('navbar', navbar);
            return { ...state, navbar };
        }
        case 'toggleSemidark': {
            const semidark = actionPayload || false;
            localStorage.setItem('semidark', semidark);
            return { ...state, semidark };
        }
        case 'toggleLocale': {
            const locale = actionPayload || state.locale;
            localStorage.setItem('i18n_locale', locale);
            return { ...state, locale };
        }
        case 'toggleSidebar':
            return { ...state, sidebar: !state.sidebar };
        default:
            return state;
    }
}
